import { User } from 'lib-shared-types-api';

import { ConversationAuditLogEntry } from 'apis/auditLogs';

import { Message } from '../../../conversation/components/message';

import { getLogEntryAuthorName, LogEntry } from './logEntry';
import styles from './logEntry/logEntry.module.scss';
import { UserLink } from './userLink/userLink';

type NoteAddedProps = {
  entry: ConversationAuditLogEntry<'NOTE_ADDED'>;
};

export const NoteAdded = ({ entry }: NoteAddedProps): JSX.Element => {
  const authorName = getLogEntryAuthorName(entry);
  const authorLink = <UserLink userId={entry.author.id}>{authorName}</UserLink>;

  const text = <>Internal note is added by {authorLink}</>;

  const messageAuthor: User = {
    id: entry.author.id,
    name: entry.author.name ?? null,
    email: entry.author.email ?? null,
    phone_number: entry.author.phone_number ?? null,
    avatar_url: entry.avatar_url ?? null,
    type: 'member',
    org_id: null,
    company_id: null,
    default_outbound_number: null,
    anonymized_at: null,
    given_name: null,
    family_name: null,
    has_scim_enabled: false,
    external_id: null,
  };

  return (
    <LogEntry entry={entry} text={text}>
      <Message
        className={styles.message}
        internal
        author={messageAuthor}
        markup={entry.message}
        date=""
      />
    </LogEntry>
  );
};
